module.exports = __webpack_public_path__ + "img/f2.090ad3f2.png";